module.exports = __webpack_public_path__ + "static/media/card-diamond.f402d749.svg";